import { Environment } from '@dice/app/types/env.type';
import { INT_ENV_CONFIG } from '@dice/environments/int/int.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const INT_BLUE_ENV_CONFIG: Environment = {
  ...INT_ENV_CONFIG,
  hostNames: ['dice-int-blue.scapp-corp.swisscom.com', 'dice-ui-blue-green-int.scapp-corp.swisscom.com'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-int-blue',
  logLevel: NgxLoggerLevel.DEBUG,
};
